import Button from '@mui/material/Button';
import Grid2 from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';

export const LoginOrGuestStep = ({ onProceed }: { onProceed: () => void }) => {
  const navigate = useNavigate();
  return (
    <Grid2 size={{ xs: 12 }}>
      <Typography variant="body1" gutterBottom>
        Masz już konto w Turnieje.org? Zaloguj się, aby szybciej zapisać drużynę.
      </Typography>
      <Grid2 container spacing={2}>
        <Grid2>
          <Button
            variant="contained"
            onClick={() => navigate(`/login?redirectTo=${encodeURIComponent(window.location.pathname)}`)}
          >
            Zaloguj
          </Button>
        </Grid2>
        <Grid2>
          <Button variant="outlined" onClick={onProceed}>
            Kontynuuj jako gość
          </Button>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};
